export default __webpack_public_path__ + "static/media/screen1.785eb013.jpg";